const diffInMills = (dateStr1, dateStr2) => {
    const date1 = new Date(dateStr1).getTime();
    const date2 = new Date(dateStr2).getTime();

    return date2 - date1;
}

export const transformItem = (input, index, {earliestStart}) => {
    const start = diffInMills(earliestStart, input.started)

    return {
        id: index,
        name: input.service,
        duration: input.duration,
        start
    }
}

export const findEarliestStart = (data) => {
    if (!data || data.length === 0) {
        return null;
    }

    return data.map(item => item.started).sort()[0]
}

export const transformData = (data) => {
    const earliestStart = findEarliestStart(data);
    return data
        .map((item, idx) => transformItem(item, idx, {earliestStart}))
        .sort((a,b) => a.start - b.start )
        .filter(item => item.duration > 5)
}
